import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ComicCard from '@/components/feature/ComicCard';
import { getComicsByCategory } from '@/mocks/comics';
import { categories } from '@/mocks/categories';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const currentCategory = categories.find((c) => c.slug === slug) || categories[0];
  const filteredComics = getComicsByCategory(slug || 'all');

  const jsonLdWebPage = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${currentCategory.name}漫画 - 漫画皮`,
    description: `漫画皮${currentCategory.name}漫画分类，高清好看的${currentCategory.name}网络漫画免费在线阅读。`,
    url: `http://qjmd.cn/category/${slug}`,
    isPartOf: {
      '@type': 'WebSite',
      name: '漫画皮',
      url: 'http://qjmd.cn/',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLdWebPage)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-16">
          <div className="w-full max-w-[1280px] mx-auto px-6 md:px-10">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '漫画分类', href: '/category/all' },
                { label: `${currentCategory.name}漫画` },
              ]}
            />

            <div className="py-8">
              <h1 className="text-3xl md:text-4xl font-extrabold text-foreground-950 mb-3">
                {currentCategory.name}<span className="text-accent-500">漫画</span>
              </h1>
              <p className="text-foreground-500 mb-8">
                共 {filteredComics.length} 部作品 · 高清免费在线阅读
              </p>

              <div className="flex flex-wrap gap-2 mb-10">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className={`px-5 py-2 text-sm font-medium rounded-full transition-all whitespace-nowrap ${
                      cat.slug === slug
                        ? 'bg-accent-500 text-background-50'
                        : 'border border-background-200/70 text-foreground-600 hover:border-accent-500 hover:text-accent-500'
                    }`}
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>

              {filteredComics.length > 0 ? (
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-5">
                  {filteredComics.map((comic) => (
                    <ComicCard key={comic.id} comic={comic} />
                  ))}
                </div>
              ) : (
                <div className="text-center py-20">
                  <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-background-100 flex items-center justify-center">
                    <i className="ri-emotion-sad-line text-3xl text-foreground-300"></i>
                  </div>
                  <p className="text-foreground-500">该分类暂无漫画作品</p>
                  <Link
                    to="/category/all"
                    className="inline-block mt-4 px-6 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-all whitespace-nowrap"
                  >
                    查看全部漫画
                  </Link>
                </div>
              )}
            </div>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
}